module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "printviewdisbursementcollectioncenterwise"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-lg"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header bg-aqua"
  }, [_vm._m(0), _vm._v(" "), _c('button', {
    staticClass: "float-right btn btn-sm btn-primary",
    on: {
      "click": function($event) {
        return _vm.printdisbursementcollectioncenterwise()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-print"
  }), _vm._v(" Print")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body",
    attrs: {
      "id": "printdisbursementcollectioncenterwise"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "card card-primary card-outline"
  }, [_c('div', {
    staticClass: "card-body box-profile"
  }, [_c('table', {
    staticClass: "table table-condensed"
  }, [_c('thead', [_c('td', [_c('img', {
    attrs: {
      "src": _vm.logo,
      "height": "100",
      "width": "100%"
    }
  })]), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }, [_c('h4', [_c('strong', [_vm._v(_vm._s(_vm.getCompanyRecord.companyName))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('small', [_vm._v("Address : " + _vm._s(_vm.getCompanyRecord.address) + ", " + _vm._s(_vm.getCompanyRecord.city) + ", " + _vm._s(_vm.getCompanyRecord.state) + " - " + _vm._s(_vm.getCompanyRecord.pin) + "\n                        "), _c('br'), _vm._v("CIN : " + _vm._s(_vm.getCompanyRecord.cin) + ", Website - " + _vm._s(_vm.getCompanyRecord.url) + ", Mobile No - " + _vm._s(_vm.getCompanyRecord.phone) + ", Email ID - " + _vm._s(_vm.getCompanyRecord.email) + "\n                        ")]), _c('br'), _c('br'), _c('strong', [_vm._v("LOAN APPLICATION FORM")])])])])]), _vm._v(" "), _c('hr', {
    attrs: {
      "width": "100%"
    }
  }), _vm._v(" "), _c('p', [_vm._v("We here by agree that we are forming a group for loan(IGL) to income generation purpose and we will follow  all rules and regulations of " + _vm._s(_vm.getCompanyRecord.companyName) + " and also  mutually agree to pay all dues and EMI of " + _vm._s(_vm.getCompanyRecord.companyName) + " and we are also agree to arrange a weekly meeting to loan payment purpose.")]), _vm._v(" "), (_vm.canAccess('loan-disbursement-view-any')) ? _c('div', {
    staticClass: "info-box"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6 col-xs-6"
  }, [(Object.keys(_vm.branch).length !== 0) ? _c('label', [_vm._v("\n                                   Branch : " + _vm._s(_vm.branch.name) + " (" + _vm._s(_vm.branch.branchCode) + ") "), _c('br'), _vm._v("\n                                   Group Leader :"), (_vm.seeRecords[0]) ? _c('i', [_vm._v(" " + _vm._s(_vm.seeRecords[0].collection_center_leader.name) + " ")]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 col-xs-6"
  }, [_c('div', {
    staticClass: "pull-right"
  }, [(Object.keys(_vm.collectionCenter).length !== 0) ? _c('label', [_vm._v("\n                                        Group Name : " + _vm._s(_vm.collectionCenter.name) + " "), _c('br'), _vm._v("\n                                        Address: " + _vm._s(_vm.collectionCenter.address) + "\n                                    ")]) : _vm._e()])])]), _vm._v(" "), _c('table', {
    staticClass: "table table-sm table-bordered table-hover"
  }, [_vm._m(2), _vm._v(" "), _vm._l((_vm.seeRecords), function(row, index) {
    return _c('tbody', {
      key: index
    }, [_c('tr', [_c('td', {
      staticClass: "hidden-xs",
      attrs: {
        "rowspan": "2"
      }
    }, [_vm._v(_vm._s((index + 1)))]), _vm._v(" "), _c('td', [(row.member) ? _c('i', [_vm._v(_vm._s(row.member.name)), _c('br'), _vm._v("(" + _vm._s(row.member.code) + ")")]) : _vm._e()]), _vm._v(" "), _c('td', [(row.guarantor) ? _c('span', [_vm._v(_vm._s(row.guarantor.name)), _c('br'), _vm._v("(" + _vm._s(row.guarantor.code) + ")")]) : _vm._e()]), _vm._v(" "), _c('td', {
      staticClass: "hidden-xs"
    }, [_vm._v(_vm._s(_vm.planName(row.plan)))]), _vm._v(" "), _c('td', {
      staticClass: "hidden-xs"
    }, [_vm._v(_vm._s(_vm.planRecoveryType(row.plan)))]), _vm._v(" "), _c('td', [(row.loanAmount) ? _c('b', [_vm._v(_vm._s(row.loanAmount))]) : _c('b', [_vm._v(_vm._s(_vm.planAmt(row.plan)))])]), _vm._v(" "), _c('td', {
      staticClass: "hidden-xs"
    }, [_vm._v(_vm._s(_vm.loanTenure(row.plan)))]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td')]), _vm._v(" "), _c('tr', [_c('td', {
      attrs: {
        "colspan": "7"
      }
    }, [_c('strong', [_vm._v("Spouse : " + _vm._s(row.member.member_profile.spouseName))]), _vm._v(" "), _c('strong', [_vm._v("Staff :")]), _vm._v(" " + _vm._s(row.agent.name) + " \n                                    "), (Object.keys(_vm.collectionCenter).length === 0) ? _c('span', [_c('strong', [_vm._v("     Group Name :")]), _vm._v(" " + _vm._s(row.collection_center.name) + " (" + _vm._s(row.collection_center.centerCode) + ")")]) : _vm._e(), _vm._v(" "), _c('span', [_vm._v("     "), _c('strong', [_vm._v("File Charge :")]), _vm._v(" " + _vm._s(_vm.loanFileCharge(row.plan)))]), _vm._v(" "), _c('span', [_vm._v("     "), _c('strong', [_vm._v("EMI :")]), _vm._v(" "), (_vm.loanEMI(row.plan) !== 0) ? _c('i', [_vm._v(_vm._s(_vm.loanEMI(row.plan)))]) : _vm._e()])]), _vm._v(" "), _c('td', [_vm._v("Date: ")])])])
  })], 2)])]) : _vm._e()])])])])]), _vm._v(" "), _vm._m(3)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Group Disbursement List")]), _vm._v(" "), _c('div', {
    staticClass: "box-tools"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', {
    staticStyle: {
      "background-color": "#d6dddd"
    }
  }, [_c('tr', [_c('th', {
    staticClass: "hidden-xs"
  }, [_vm._v("Sr.")]), _vm._v(" "), _c('th', [_vm._v("Member")]), _vm._v(" "), _c('th', [_vm._v("Guarantor")]), _vm._v(" "), _c('th', {
    staticClass: "hidden-xs"
  }, [_vm._v("Loan Type")]), _vm._v(" "), _c('th', {
    staticClass: "hidden-xs"
  }, [_vm._v("Loan Cycle")]), _vm._v(" "), _c('th', [_vm._v("Loan Amt")]), _vm._v(" "), _c('th', [_vm._v("Loan Tenure")]), _vm._v(" "), _c('th', [_vm._v("Loan Purpose")]), _vm._v(" "), _c('th', {
    staticClass: "hidden-xs"
  }, [_vm._v("Member Signature")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-footer text-center"
  }, [_c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("\n            CLOSE\n          ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-a7c120aa!./~/vue-loader/lib/selector.js?type=template&index=0!./src/microfinance/components/PrintViewDisbursementCollectionCenterWise.vue
// module id = 922
// module chunks = 0